import type { CheckboxesProps } from '@/components/checkboxes/checkboxes.types';
import clsx from 'clsx';
import Checkbox from '@/components/checkbox';
import '@/components/checkboxes/checkboxes.css';

export default function Checkboxes(props: CheckboxesProps) {
  const { isDisabled = false, orientation = 'column', value = [], choices = [], name = '', onChange } = props;

  const hasSomeInfo = choices.some((choice) => !!choice.info);
  const hasNoInfo = choices.every((choice) => !choice.info);

  return (
    <div
      className={clsx('checkboxes', {
        ['checkboxes--row']: orientation === 'row' && hasNoInfo,
        ['checkboxes--column']: orientation === 'column' || hasSomeInfo,
      })}
    >
      {choices.map((choice) => (
        <div
          key={choice.value}
          className={clsx('checkboxes__item', {
            ['checkboxes__item--row']: orientation === 'row' && hasNoInfo,
            ['checkboxes__item--column']: orientation === 'column' || hasSomeInfo,
          })}
        >
          <Checkbox
            disabled={isDisabled}
            value={value.includes(choice.value)}
            name={choice.value}
            label={choice.label}
            info={choice.info}
            onChange={(v, n) => onChange(name, n, v)}
          />
        </div>
      ))}
    </div>
  );
}
